<style lang="less" scoped>
  @q-blue: #0077db;

  header {
    height: 68px;
    border-bottom: 1px solid #dcdbdb;
    box-shadow: 0 2px 2px #f3f3f3;
  }

  header h1 {
    margin-bottom: 12px;
    color: #494949;
    font-size: 24px;
  }

  header ul {
    margin-left: 50px;
    float: left;
    li {
      float: left;
      color: @q-blue;
      a {
        /*color: #0077db;*/
        color: #282828;
        font-size: 16px;
        letter-spacing: 2px;
        display: inline-block;
        margin: 0 20px;
        height: 68px;
        line-height: 68px;
        border-bottom: 2px solid transparent;

        &:hover {
          color: @q-blue;
          border-bottom: 2px solid @q-blue;
        }
      }
      &.active a {
        /*color: #0077db;*/
        color: #282828;
        font-size: 16px;
        letter-spacing: 2px;
        display: inline-block;
        margin: 0 20px;
        height: 68px;
        line-height: 68px;
        border-bottom: 2px solid @q-blue;

        &:hover {
          color: @q-blue;
          border-bottom: 2px solid @q-blue;
        }
      }

    }
  }

</style>
<template>

  <header>
    <div class="container">
      <div class="logo l">
        <router-link to="/">
          <img style="height: 44px; margin-top: 10px; margin-left: 10px;"
               src="//official.cdn.qiyewan.com/logo_qiyewna.png" alt="企业湾logo" title="企业湾logo">
        </router-link>
        <div class=""></div>
      </div>
      <ul>
        <li v-for="item in categories" :class="{active: isActive(item.id)}">
          <router-link :to="{path: item.href, query: {category: item.id}}">{{ item.name }}</router-link>
        </li>
      </ul>
    </div>
  </header>

</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    props: {
      categoryId: Number,
    },
    data () {
      return {

      }
    },
    computed: {
      ...mapGetters({
        categories: 'getHeaderCategories',
      }),
    },
    created(){

    },
    methods: {
      isActive (categoryId) {
//        console.log(this.categoryId === categoryId)
        return this.categoryId === categoryId
      }
    }

  }
</script>




// WEBPACK FOOTER //
// Header.vue?060f5f58